import React from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardImg,
  CardBody,
  Col,
  Row,
  Button,
  Input,
  Label,
  CardFooter,
  FormGroup,
  Form,
} from "reactstrap";
import * as Server from "../Server";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

class PrayerPageIconsEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      file: {},
      fileName: "",
      icon: props.icon || {},
    };
    this.updateIconDetails = this.updateIconDetails.bind(this);
    this.createIconDetails = this.createIconDetails.bind(this);
  }

  componentDidMount() {}

  createIconDetails = async (event) => {
    try {
      event.preventDefault();
      if (!this.state.fileName) {
        this.notificationSystem.addNotification({
          message: "Select the file",
          level: "error",
        });
        return;
      }
      this.setState({ showLoader: true });
      let formData = new FormData();
      formData.append("url", this.state.icon.url);
      formData.append("name", this.state.icon.name);
      formData.append("prayerPageIcon", this.state.file);
      let response = await Server.serverRequest({
        url: "prayerPage/create",
        method: "POST",
        data: formData,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateIconDetails = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let formData = new FormData();
      formData.append("url", this.state.icon.url);
      formData.append("name", this.state.icon.name);
      formData.append("iconId", this.state.icon._id);
      if (this.state.fileName) {
        formData.append("prayerPageIcon", this.state.file);
      }
      let response = await Server.serverRequest({
        url: "/prayerPage/updateIconDetails",
        method: "POST",
        data: formData,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    this.setState({
      file: fileUploaded,
      fileName: fileUploaded.name,
    });
  };

  closeEditPage = (value) => {
    this.props.closePrayerPageIconEditPage({ refreshList: value });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title={
            this.props.editSubCategoryKey
              ? "Edit Prayer Page Icons"
              : "Add Prayer Page Icons"
          }
          breadcrumbs={[
            {
              name: this.props.editSubCategoryKey
                ? "Edit Prayer Page Icons"
                : "Add Prayer Page Icons",
              active: true,
            },
          ]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <Form
                    onSubmit={
                      this.props.editSubCategoryKey
                        ? this.updateIconDetails
                        : this.createIconDetails
                    }
                  >
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="name">Name</Label>
                          <Input
                            type="text"
                            name="name"
                            required
                            value={this.state.icon.name || ""}
                            placeholder="Name"
                            autoComplete="off"
                            onChange={(event) =>
                              this.setState({
                                icon: {
                                  ...this.state.icon,
                                  name: event.target.value,
                                },
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <Label for="name">Url</Label>
                        <Input
                          type="text"
                          name="name"
                          required
                          value={this.state.icon.url || ""}
                          placeholder="Name"
                          autoComplete="off"
                          onChange={(event) =>
                            this.setState({
                              icon: {
                                ...this.state.icon,
                                url: event.target.value,
                              },
                            })
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label>Icon</Label>
                          <br />
                          {this.state.icon.icon ? (
                            <CardImg
                              style={{ width: "50%" }}
                              src={this.state.icon.icon}
                              alt=""
                            ></CardImg>
                          ) : (
                            "No Image"
                          )}
                          <br />
                          <Label htmlFor="file" style={{ marginTop: "30px" }}>
                            <span className="btn btn-secondary">
                              Select File
                            </span>
                            <span style={{ marginLeft: "5px" }}>
                              {this.state.fileName}
                            </span>
                          </Label>
                          <input
                            style={{ display: "none" }}
                            id="file"
                            type="file"
                            accept=".png,.jpg,.jpeg"
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {this.props.editSubCategoryKey ? (
                          <Button color="primary" type="submit">
                            Update
                          </Button>
                        ) : (
                          <Button color="primary" type="submit">
                            Create
                          </Button>
                        )}
                      </Col>
                      <Col>
                        <Button
                          color="secondary"
                          onClick={(event) => {
                            this.closeEditPage(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default PrayerPageIconsEdit;
